import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useResetPasswordMutation } from '@/query/auth.query';

import { cn } from '@/lib/utils';

import { ResetPasswordForm } from './form';

import { ResetPasswordFormProvider } from '@/formik/auth.formik';

export interface ResetPasswordState {
  name: string;
  username: string;
  session: string;
}

export const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as ResetPasswordState;

  useEffect(() => {
    if (!state || !state.session) {
      navigate('/login');
    }
  }, [state]);

  const mutation = useResetPasswordMutation({
    onSuccess: () => {
      navigate('/login');
    },
  });

  return (
    <div className={cn('flex min-h-screen items-center justify-center')}>
      <div className={cn('flex flex-col gap-6 w-full max-w-md px-4')}>
        <div className="flex flex-col items-center gap-2 text-center">
          <h1 className="text-2xl font-bold">Reset your password?</h1>
        </div>
        <ResetPasswordFormProvider
          onSubmit={values => mutation.mutate({ data: values, extra: state })}
        >
          <ResetPasswordForm isLoading={mutation.isPending} />
        </ResetPasswordFormProvider>
      </div>
    </div>
  );
};
